/**
 * Markdown → sanitized HTML for stored report content.
 *
 * The backend stores each report as Markdown; the frontend renders it via
 * `dangerouslySetInnerHTML`, so every conversion MUST pass through DOMPurify.
 */

import DOMPurify from "dompurify";
import { marked } from "marked";

export function renderMarkdown(md: string): string {
  const html = marked.parse(md, { async: false });
  return DOMPurify.sanitize(html);
}
